import React from "react";
import { Box, Drawer, List } from "@mui/material";
import projectIcon from "../../assets/icons/Projects.svg";
import homeIcon from "../../assets/icons/Home.svg";
import modelIcon from "../../assets/icons/models.svg";
import datasetIcon from "../../assets/icons/datasets.svg";
import settingsIcon from "../../assets/icons/Settings.svg";
import helpIcon from "../../assets/icons/Help.svg";
import licenseIcon from "../../assets/icons/LicenseManagement.svg";
import { VisionStudioSidebarItem } from "../../components";
import { SidebarItemProps } from "../../types/interface";

/**
 *
 * Componet to display the SideBar UI with the menu icons.
 *
 */
export const Sidebar: React.FC = () => {
  const sideBarTopItems: SidebarItemProps[] = [
    { title: "Home", icon: homeIcon, link: "dashboard" },
    { title: "Projects", icon: projectIcon, link: "projects" },
    // { title: "Datasets", icon: datasetIcon, link: "dataset" },
    { title: "Models", icon: modelIcon, link: "models" },
  ];

  const sideBarBottomItems: SidebarItemProps[] = [
    {
      title: "Manage License",
      icon: licenseIcon,
      link: "license-management-external"
    },
    // { title: "Settings", icon: settingsIcon, link: "setting" },
    // { title: "Help", icon: helpIcon, link: "help" },
  ];

  return (
    <Box>
      <Drawer
        variant="permanent"
        anchor="left"
        PaperProps={{
          style: {
            border: "none",
            top: "50px",
            height: "calc(100vh - 90px)",
            justifyContent: "space-between",
            overflowX: "hidden",
            zIndex: "auto",
          },
        }}
      >
        <List
          style={{
            width: "64px",
            textAlign: "center",
            paddingTop: "0",
          }}
        >
          {sideBarTopItems?.map((item, index) => {
            return (
              <VisionStudioSidebarItem
                key={index}
                title={item.title}
                icon={item.icon}
                link={item.link}
              />
            );
          })}
        </List>

        <List
          style={{
            width: "64px",
            textAlign: "center",
            paddingTop: "0",
          }}
        >
          {sideBarBottomItems?.map((item, index) => {
            if (item.link === "license-management-external") {
              return (
                <div
                  key={index}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    padding: "10px 2px",
                    marginBottom: "24px", // Less space below License Management
                    marginTop: "-8px", // Move a bit higher
                  }}
                  onClick={() => window.open("/PlanEnterprise", "_blank")}
                >
                  <img src={item.icon} alt="License Management" style={{ height: "20px", width: "20px", filter: "grayscale(100%) brightness(0.6)" }} />
                  <span style={{ fontSize: "0.75rem", fontWeight: "400", lineHeight: "18px", color: "rgb(0, 0, 0)", marginTop: "4px" }}>Manage License</span>
                </div>
              );
            }
            return (
              <VisionStudioSidebarItem
                key={index}
                title={item.title}
                icon={item.icon}
                link={item.link}
              />
            );
          })}
        </List>
      </Drawer>
    </Box>
  );
};
